import { usePhonePairing } from '../context/PhonePairingContext';

export function useWebRtcPairing() {
  return usePhonePairing();
}
